import { render, staticRenderFns } from "./schedule-groupappointmentpatientslist.vue?vue&type=template&id=317d4ec8&"
import script from "./schedule-groupappointmentpatientslist.vue?vue&type=script&lang=js&"
export * from "./schedule-groupappointmentpatientslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports